import uniqBy from 'lodash/uniqBy';

export const parseSet = (breadcrumbs, breadcrumb) => {
  let newBreadcrumbs = (breadcrumbs || []).filter((item) => item.default);
  newBreadcrumbs = newBreadcrumbs.concat(breadcrumb || []);
  return uniqBy(newBreadcrumbs, 'id');
};
